'use strict';

export default function ($stateProvider, $urlRouterProvider) {
  'ngInject';

  $urlRouterProvider.when("/writetpl", "/writetpl/list");

  $stateProvider
    .state('writetpl', {
      url: '/writetpl',
      template: require('./writeTpl.html'),
      authenticate: true
    })
    .state('writetpl.list', {
      url: '/list',
      template: require('./list/list.html'),
      controller: 'WriteTplListController',
      controllerAs: 'wtListCtrl'
    })
    .state('writetpl.add', {
      url: '/add',
      template: require('./add/add.html'),
      controller: 'WriteTplAddController',
      controllerAs: 'wtAddCtrl'
    })
    .state('writetpl.edit', {
      url: '/edit/:id',
      template: require('./edit/edit.html'),
      controller: 'WriteTplEditController',
      controllerAs: 'wtEditCtrl'
    });
}



// WEBPACK FOOTER //
// ./client/app/writeTpl/writeTpl.routes.js